import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
        this.container = null;
        this.originalText = '';
        this.resizeObserver = null;
    }

    init() {
        this.container = this.el;
        if (!this.container) return;

        this.originalText = this.container.innerHTML.trim();
        this.split_into_lines();

        // ResizeObserver for container size changes
        this.resizeObserver = new ResizeObserver(() => {
            this.split_into_lines();
        });
        this.resizeObserver.observe(this.container);

        // Fallback for window resize events
        this.handleWindowResize = () => {
            this.split_into_lines();
        };
        window.addEventListener('resize', this.handleWindowResize);
    }

    split_into_lines() {
        if (!this.container) return;

        // Stocke le texte original et vide le container
        const raw_chunks = this.originalText.split(' ');
        let words = [];
        let word_types = []; // true = is part of hyphenated group

        raw_chunks.forEach(chunk => {
            if (chunk.includes('-')) {
                const parts = chunk.split('-');

                parts.forEach((part, index) => {
                    const is_last = index === parts.length - 1;
                    const full_part = is_last ? part : part + '-';
                    if (full_part) {
                        words.push(full_part);
                        word_types.push(true); // this is part of a hyphenated word
                    }
                });
            } else {
                words.push(chunk);
                word_types.push(false); // regular word
            }
        });
        this.container.innerHTML = '';

        // Ajoute chaque mot dans un span temporaire pour détecter les sauts de ligne
        let temp_spans = [];
        words.forEach((word, index) => {
            const temp_span = document.createElement('span');

            // Ajouter &#8200; *seulement* si ce n’est pas un mot lié par un tiret
            const should_add_space = !word_types[index] && index !== words.length - 1;
            const should_add_another_space = word_types[index] == true && word_types[index + 1] == false;

            temp_span.innerHTML = word + (should_add_space ? '&#8200;' : '') + (should_add_another_space ? '&#8200;' : '');
            this.container.appendChild(temp_span);
            temp_spans.push(temp_span);
        });

        // Détection des lignes
        let last_offset_top = temp_spans[0]?.offsetTop;
        let current_line = [];
        let final_spans = [];

        temp_spans.forEach((span, index) => {
            let offset_top = span.offsetTop;

            if (offset_top !== last_offset_top) {
                final_spans.push(this.create_span(current_line));
                current_line = [];
                last_offset_top = offset_top;
            }

            current_line.push(span.innerHTML);
        });

        if (current_line.length > 0) {
            final_spans.push(this.create_span(current_line));
        }

        // Remplace le contenu par les nouvelles lignes détectées
        this.container.innerHTML = '';
        final_spans.forEach(span => this.container.appendChild(span));
        // remove &#8200; and replace with a space
        this.container.innerHTML = this.container.innerHTML.replace(/&#8200;/g, ' ');
        // remove spaces after the last word of each line
        this.container.innerHTML = this.container.innerHTML.replace(/(\s+)(<\/span>)/g, '$2');
    }

    create_span(words) {
        // Crée un conteneur parent
        const parentSpan = document.createElement('span');
        parentSpan.classList.add('split-line-container');

        // Crée un span enfant
        const childSpan = document.createElement('span');
        childSpan.classList.add('split-line');
        childSpan.innerHTML = words.join('');

        // Ajoute le span enfant au conteneur parent
        parentSpan.appendChild(childSpan);

        return parentSpan;
    }

    destroy() {
        // Disconnect ResizeObserver
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }

        // Remove window resize event listener
        if (this.handleWindowResize) {
            window.removeEventListener('resize', this.handleWindowResize);
            this.handleWindowResize = null;
        }

        // Restore original content
        this.container.innerHTML = this.originalText;
    }
}
